import React from 'react';
import { Flex, List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { RedTimes, TableView, TitleTag } from '~/stylizations/styles';
import FinancialClosingPayAndLoss from './financialClosingPayAndLoss';
import { formatPrice, parsePrice } from '~/Utils/format';
import Button from '~/components/Button';

export default function Real({ values, handlePdf, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const mobileLabel = (text) => (
    <div>
      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>
    </div>
  );
  const child = (text) => {
    if (text == null || text == '') {
      return (
        <div style={{ textAlign: 'center' }}>
          <RedTimes />
        </div>
      );
    }

    return <span style={{ fontSize: isMobile ? '12px' : '15px', fontWeight: 'bold' }}>{t(`${text}`)}</span>;
  };

  const paymentsFields = (values?.event_financial_payments?.length ? values.event_financial_payments : [{}]).flatMap(
    (payment, i) => [
      { label: `Pagamento ${i + 1} - Nome`, value: payment?.name },
      { label: `Pagamento ${i + 1} - Valor`, value: payment?.price },
    ]
  );

  const lossesFields = (values?.event_financial_losses?.length ? values.event_financial_losses : [{}]).flatMap(
    (loss, i) => [
      { label: `Sobra/Falta ${i + 1} - Nome`, value: loss?.name },
      { label: `Sobra/Falta ${i + 1} - Valor`, value: loss?.price },
    ]
  );

  const data = [...paymentsFields, ...lossesFields];

  return isMobile ? (
    <List
      bordered
      dataSource={data}
      renderItem={({ label, value }) => (
        <List.Item>
          <Typography.Text strong>{mobileLabel(label)}</Typography.Text>
          {child(value)}
        </List.Item>
      )}
    />
  ) : (
    <>
      <Flex align="center" justify="end">
        <Button color="primary" onClick={() => handlePdf(values, 'real-report')}>
          {t('Emitir fechamento real')}
        </Button>
      </Flex>
      <TitleTag>{label('VALORES')}</TitleTag>
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          {
            title: label('Débito bruto'),
            dataIndex: 'debit_raw_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
          {
            title: label('Crédito bruto'),
            dataIndex: 'credit_raw_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
          {
            title: label('Pix bruto'),
            dataIndex: 'pix_raw_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
        ]}
        dataSource={[values]}
      />
      <TitleTag>{label('TOTAL')}</TitleTag>
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          {
            title: label('Total líquido real'),
            dataIndex: 'revenues_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
          {
            title: label('Total líquido cliente'),
            dataIndex: 'total_liquid_client',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
          {
            title: label('Ágio de taxa admninistrativa total'),
            dataIndex: 'agio_total',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
        ]}
        dataSource={[values]}
      />
      <FinancialClosingPayAndLoss values={values} isMobile={isMobile} />
      {/* <TitleTag>{label('TOTAL FINAL')}</TitleTag> */}
      {/* <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          {
            title: label('Real'),
            dataIndex: 'final_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
          {
            title: label('Cliente'),
            dataIndex: 'customer_final_price',
            render: (text, _) => child(formatPrice(parsePrice(text))),
          },
        ]}
        dataSource={[values]}
      /> */}
    </>
  );
}
